import {
  library,
  IconProp,
  IconDefinition,
} from '@fortawesome/fontawesome-svg-core'
import { faFacebookF } from '@fortawesome/free-brands-svg-icons/faFacebookF'
import { faLinkedinIn } from '@fortawesome/free-brands-svg-icons/faLinkedinIn'
import { faTiktok } from '@fortawesome/free-brands-svg-icons/faTiktok'
import { faXTwitter } from '@fortawesome/free-brands-svg-icons/faXTwitter'
import { faYoutube } from '@fortawesome/free-brands-svg-icons/faYoutube'
import { faEnvelope } from '@fortawesome/free-solid-svg-icons/faEnvelope'
import { faXmark } from '@fortawesome/free-solid-svg-icons/faXmark'
import { faPlus } from '@fortawesome/free-solid-svg-icons/faPlus'
import { faPlay } from '@fortawesome/free-solid-svg-icons/faPlay'
import { faCheckCircle as faCheckCircleSolid } from '@fortawesome/free-solid-svg-icons/faCheckCircle'
import { faGlobe } from '@fortawesome/free-solid-svg-icons/faGlobe'
import { faPause } from '@fortawesome/free-solid-svg-icons/faPause'
import { faExpand } from '@fortawesome/free-solid-svg-icons/faExpand'
import { faVolumeHigh } from '@fortawesome/free-solid-svg-icons/faVolumeHigh'
import { faVolumeLow } from '@fortawesome/free-solid-svg-icons/faVolumeLow'
import { faAngleRight } from '@fortawesome/free-solid-svg-icons/faAngleRight'
import { faAngleLeft } from '@fortawesome/free-solid-svg-icons/faAngleLeft'
import { faChevronDown as faChevronDownSolid } from '@fortawesome/free-solid-svg-icons/faChevronDown'
import { faChevronUp as faChevronUpSolid } from '@fortawesome/free-solid-svg-icons/faChevronUp'
import { faChevronLeft as faChevronLeftSolid } from '@fortawesome/free-solid-svg-icons/faChevronLeft'
import { faChevronRight as faChevronRightSolid } from '@fortawesome/free-solid-svg-icons/faChevronRight'
import { faVolumeMute } from '@fortawesome/free-solid-svg-icons/faVolumeMute'
import { faCompress } from '@fortawesome/free-solid-svg-icons/faCompress'
import { faDownload as faDownloadSolid } from '@fortawesome/free-solid-svg-icons/faDownload'
import { faArrowUpRightFromSquare } from '@fortawesome/free-solid-svg-icons/faArrowUpRightFromSquare'
import { faHeadset } from '@fortawesome/free-solid-svg-icons/faHeadset'
import { faCircleInfo as faCircleInfoSolid } from '@fortawesome/free-solid-svg-icons/faCircleInfo'
import { faCircleExclamation as faCircleExclamationSolid } from '@fortawesome/free-solid-svg-icons/faCircleExclamation'
import { faArrowLeftLong } from '@fortawesome/pro-light-svg-icons/faArrowLeftLong'
import { faExclamationCircle } from '@fortawesome/pro-light-svg-icons/faExclamationCircle'
import { faQuestionCircle } from '@fortawesome/pro-light-svg-icons/faQuestionCircle'
import { faChevronDown } from '@fortawesome/pro-light-svg-icons/faChevronDown'
import { faChevronUp } from '@fortawesome/pro-light-svg-icons/faChevronUp'
import { faChevronLeft } from '@fortawesome/pro-light-svg-icons/faChevronLeft'
import { faChevronRight } from '@fortawesome/pro-light-svg-icons/faChevronRight'
import { faArrowRight } from '@fortawesome/pro-light-svg-icons/faArrowRight'
import { faCalendarAlt } from '@fortawesome/pro-light-svg-icons/faCalendarAlt'
import { faClock } from '@fortawesome/pro-light-svg-icons/faClock'
import { faCheck } from '@fortawesome/pro-light-svg-icons/faCheck'
import { faHourglass } from '@fortawesome/pro-light-svg-icons/faHourglass'
import { faLockKeyhole } from '@fortawesome/pro-light-svg-icons/faLockKeyhole'
import { faCheckCircle } from '@fortawesome/pro-light-svg-icons/faCheckCircle'
import { faTurnDownRight } from '@fortawesome/pro-light-svg-icons/faTurnDownRight'
import { faDownload } from '@fortawesome/pro-light-svg-icons/faDownload'
import { faBooks } from '@fortawesome/pro-light-svg-icons/faBooks'
import { faBookAlt } from '@fortawesome/pro-light-svg-icons/faBookAlt'
import { faXmark as faXmarkLight } from '@fortawesome/pro-light-svg-icons/faXmark'
import { faSignalStream } from '@fortawesome/pro-light-svg-icons/faSignalStream'
import { faTrashCan } from '@fortawesome/pro-light-svg-icons/faTrashCan'
import { faCartShopping } from '@fortawesome/pro-light-svg-icons/faCartShopping'
import { faWallet } from '@fortawesome/pro-light-svg-icons/faWallet'
import { faCreditCard } from '@fortawesome/pro-light-svg-icons/faCreditCard'
import { faBadgeDollar } from '@fortawesome/pro-light-svg-icons/faBadgeDollar'
import { faTriangleExclamation } from '@fortawesome/pro-light-svg-icons/faTriangleExclamation'
import { faCircleInfo } from '@fortawesome/pro-light-svg-icons/faCircleInfo'
import { faFile } from '@fortawesome/pro-light-svg-icons/faFile'
import { faFileSignature } from '@fortawesome/pro-light-svg-icons/faFileSignature'
import { faMicrophone } from '@fortawesome/pro-light-svg-icons/faMicrophone'
import { faFileWord } from '@fortawesome/pro-light-svg-icons/faFileWord'
import { faPlay as faPlayLight } from '@fortawesome/pro-light-svg-icons/faPlay'
import { faImage } from '@fortawesome/pro-light-svg-icons/faImage'
import { faVideo } from '@fortawesome/pro-light-svg-icons/faVideo'
import { faFilePdf } from '@fortawesome/pro-light-svg-icons/faFilePdf'
import { faFileSpreadsheet } from '@fortawesome/pro-light-svg-icons/faFileSpreadsheet'
import { faUserGraduate } from '@fortawesome/pro-light-svg-icons/faUserGraduate'
import { faDoorOpen } from '@fortawesome/pro-light-svg-icons/faDoorOpen'
import { faUser } from '@fortawesome/pro-light-svg-icons/faUser'
import { faUsdCircle } from '@fortawesome/pro-light-svg-icons/faUsdCircle'
import { faEnvelope as faEnvelopeLight } from '@fortawesome/pro-light-svg-icons/faEnvelope'
import { faHouse } from '@fortawesome/pro-light-svg-icons/faHouse'
import { faBagShopping } from '@fortawesome/pro-light-svg-icons/faBagShopping'
import { faUserHeadset } from '@fortawesome/pro-light-svg-icons/faUserHeadset'
import { faUserCircle } from '@fortawesome/pro-light-svg-icons/faUserCircle'
import { faTrophyStar } from '@fortawesome/pro-light-svg-icons/faTrophyStar'
import { faExpand as faExpandLight } from '@fortawesome/pro-light-svg-icons/faExpand'
import { faGear } from '@fortawesome/pro-light-svg-icons/faGear'
import { faSliders } from '@fortawesome/pro-light-svg-icons/faSliders'
import { faWifiSlash } from '@fortawesome/pro-light-svg-icons/faWifiSlash'
import { faGlobe as faGlobeLight } from '@fortawesome/pro-light-svg-icons/faGlobe'
import { faGlobePointer } from '@fortawesome/pro-light-svg-icons/faGlobePointer'
import {
  faEye,
  faEye as faEyeLight,
} from '@fortawesome/pro-light-svg-icons/faEye'
import { faEyeSlash as faEyeSlashLight } from '@fortawesome/pro-light-svg-icons/faEyeSlash'
import { faLightbulb as faLightbulbLight } from '@fortawesome/pro-light-svg-icons/faLightbulb'
import { faFileContract } from '@fortawesome/pro-light-svg-icons/faFileContract'
import { faShieldHalved } from '@fortawesome/pro-light-svg-icons/faShieldHalved'
import { faHourglassClock } from '@fortawesome/pro-light-svg-icons/faHourglassClock'
import { faArrowUp } from '@fortawesome/pro-light-svg-icons/faArrowUp'
import { faMegaphone } from '@fortawesome/pro-light-svg-icons/faMegaphone'
import { faEllipsisVertical } from '@fortawesome/pro-light-svg-icons/faEllipsisVertical'
import { faComments } from '@fortawesome/pro-light-svg-icons/faComments'
import {
  FontAwesomeIcon,
  FontAwesomeIconStyle,
} from '@fortawesome/react-native-fontawesome'
import { memo } from 'react'
import { useTheme } from 'tamagui'
import {
  faWhatsappSolid,
  faInstagramSolid,
  faTwitterSolid,
  faAvancar10s,
  faVoltar10s,
  faPictureInPicture,
  faVideoSpeed,
  faPaperPlane,
} from '@awesome.me/kit-9f9823c2a0/icons/modules/kit/custom'

const CUSTOM_ICONS = {
  'whatsapp-solid': faWhatsappSolid,
  'twitter-solid': faTwitterSolid,
  'instagram-solid': faInstagramSolid,
  avancar10s: faAvancar10s,
  voltar10s: faVoltar10s,
  'picture-in-picture': faPictureInPicture,
  'video-speed': faVideoSpeed,
  'paper-plane': faPaperPlane,
}

library.add(
  faSliders,
  faVideoSpeed,
  faAvancar10s,
  faVoltar10s,
  faPictureInPicture,
  faVolumeHigh,
  faVolumeLow,
  faVolumeMute,
  faArrowLeftLong,
  faExclamationCircle,
  faVideo,
  faFilePdf,
  faExpand,
  faCompress,
  faFileSpreadsheet,
  faGear,
  faChevronDown,
  faChevronUp,
  faBagShopping,
  faChevronLeft,
  faDoorOpen,
  faEnvelopeLight,
  faXmarkLight,
  faPause,
  faUserGraduate,
  faChevronRight,
  faCalendarAlt,
  faClock,
  faCheck,
  faHouse,
  faUser,
  faUsdCircle,
  faHourglass,
  faArrowRight,
  faSignalStream,
  faCircleInfo,
  faPlayLight,
  faGlobe,
  faFile,
  faFileSignature,
  faMicrophone,
  faFileWord,
  faPlay,
  faImage,
  faTrashCan,
  faCartShopping,
  faWallet,
  faCreditCard,
  faBadgeDollar,
  faTriangleExclamation,
  faLockKeyhole,
  faCheckCircle,
  faCheckCircleSolid,
  faTurnDownRight,
  faDownload,
  faBooks,
  faBookAlt,
  faFacebookF,
  faLinkedinIn,
  faTiktok,
  faXTwitter,
  faYoutube,
  faEnvelope,
  faXmark,
  faPlus,
  faPlay,
  faUserHeadset,
  faUserCircle,
  faAngleLeft,
  faAngleRight,
  faTrophyStar,
  faChevronDownSolid,
  faChevronUpSolid,
  faChevronLeftSolid,
  faChevronRightSolid,
  faEye,
  faExpandLight,
  faDownloadSolid,
  faWifiSlash,
  faGlobeLight,
  faEyeLight,
  faEyeSlashLight,
  faGlobePointer,
  faLightbulbLight,
  faFileContract,
  faShieldHalved,
  faArrowUpRightFromSquare,
  faQuestionCircle,
  faHourglassClock,
  faHeadset,
  faArrowUp,
  faMegaphone,
  faEllipsisVertical,
  faCircleInfoSolid,
  faCircleExclamationSolid,
  faComments,
  faPaperPlane,
)

interface IHeroIconProps {
  icon: IconProp | string
  size?: number
  color?: string
  style?: FontAwesomeIconStyle
}

function isSameIcon(a: IconProp | string, b: IconProp | string) {
  if (a === b) return true
  if (Array.isArray(a) && Array.isArray(b)) {
    return a[0] === b[0] && a[1] === b[1]
  }
  return false
}

export const HeroIcon = memo(
  function HeroIcon({
    icon,
    size = 24,
    color = '$icon-default',
    style,
  }: IHeroIconProps) {
    const theme = useTheme()
    const setIcons = () => {
      if (typeof icon === 'string' && icon in CUSTOM_ICONS) {
        return CUSTOM_ICONS[icon as keyof typeof CUSTOM_ICONS] as IconDefinition
      }

      return icon as IconProp
    }
    const styleObject = Object.assign({}, style, { pointerEvents: 'none' })

    return (
      <FontAwesomeIcon
        icon={setIcons()}
        size={size}
        color={theme[color]?.val || color}
        style={styleObject}
      />
    )
  },
  (prev, next) =>
    prev.size === next.size &&
    prev.color === next.color &&
    prev.style === next.style &&
    isSameIcon(prev.icon, next.icon),
)
